import { render, staticRenderFns } from "./removedMails.vue?vue&type=template&id=23312634&scoped=true"
import script from "./removedMails.vue?vue&type=script&lang=js"
export * from "./removedMails.vue?vue&type=script&lang=js"
import style0 from "./removedMails.vue?vue&type=style&index=0&id=23312634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23312634",
  null
  
)

export default component.exports